// src/services/userService.js
import axios from 'axios';
const API_URL = `${process.env.REACT_APP_API_URL}/orders`;
export const getUserProfile = async () => {
    const id = localStorage.getItem('id');
    const token = localStorage.getItem('token');
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }});
  return response.data;
};
export const getUserAddresses = async () => {
    const id = localStorage.getItem('id');
    const token = localStorage.getItem('token');
    if (!id) throw new Error("Kullanıcı ID'si bulunamadı.");
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/address/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }});
    return response.data;
  };
  export  const addAddress = async (addressData) => {
    const userId = localStorage.getItem('id');
    const token = localStorage.getItem('token');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/address/${userId}`,
        { ...addressData }, // body içine userId
        {
          headers: {
            Authorization: `Bearer ${token}`, // header içine token
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Adres eklenirken hata oluştu:', error);
      throw error;
    }
  };
  export const deleteAddress = async (id) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/address/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Token'ı gönderiyoruz
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      console.error('Adres silme hatası:', error);
      throw error;
    }
  };
  export  const updateAddress = async (data, userId) => {
      const token = localStorage.getItem('token');
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/address/update/${data.id}`, // Güncellenen adresin id'si
        data, // Güncellenen veriler
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data; // Güncellenen adres verilerini geri döndür
    } catch (error) {
      console.error('Adres güncelleme hatası:', error);
      throw error;
    }
  };

  export const getUserOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      const id = localStorage.getItem('id');
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/orders/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
  
      return response.data; 
    } catch (error) {
      console.error("Siparişleri çekme hatası:", error);
      throw error;
    }
  };

export async function submitCardPayment(cardDetails, addressId) {
  const token = localStorage.getItem("token");

  // Yeni pencereyi kullanıcı tıklamasının hemen içinde aç!
  const win = window.open("", "KuveytTurk3DS", "width=480,height=780");
  if (!win) {
    alert("Tarayıcı pop-up engelledi. Lütfen bu site için pop-up izni verin.");
    throw new Error("Popup blocked");
  }
  win.document.open();
  win.document.write(`<html><body style="font-family:sans-serif;padding:24px">
    <h3>3D Secure sayfası yükleniyor…</h3>
    <p>Lütfen bekleyin.</p>
  </body></html>`);
  win.document.close();

  // expiry "MM/YY"
  const [mm, yy] = (cardDetails.expiry || "").split("/");
  const payload = {
    cardDetails: {
      cardNumber: cardDetails.cardNumber.replace(/\s/g, ""),
      cardExpMonth: (mm || "").padStart(2, "0"),
      cardExpYear:  (yy || "").slice(-2),
      cardCvv: cardDetails.cvc || cardDetails.cvv,
      cardHolderName: cardDetails.cardName || cardDetails.name,
      totalAmount: cardDetails.totalAmount,
      addressId,
      userId: cardDetails.userId,
      couponId: cardDetails.couponId || null,
      cartItems: cardDetails.cartItems,
    }
  };

  const res = await axios.post(`${API_URL}/credit-card`, payload, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "text",
  });

  const bankHtml = res.data;
  win.document.open();
  win.document.write(bankHtml);
  win.document.close();

  return { started: true };
}
  export const getShippingFee = async () => {
    try {
      // API'den kargo bilgilerini alıyoruz
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/getShippingInfo`);

      // Gelen veriyi alıyoruz
      const { order_min_pay, cash_payment_min, shipping_fee } = response.data;


      // Sadece 3 veri döndürüyoruz
      return {
        orderMinPay: order_min_pay,
        cashPaymentMin: cash_payment_min,
        shippingFee: shipping_fee,
      };
    } catch (error) {
      console.error('Kargo bilgisi alınamadı:', error);
      // Hata durumunda 0 değerleri döndürüyoruz
      return {
        orderMinPay: 0,
        cashPaymentMin: 0,
        shippingFee: 0,
      };
    }
  };

export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
      { email }
    );
    return response.data;
  } catch (error) {
    console.error("Şifre sıfırlama isteği hatası:", error);
    throw error;
  }
};

export const resetPassword = async (token, password) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/reset-password`,
      { token, password }
    );
    return response.data;
  } catch (error) {
    console.error("Şifre güncelleme hatası:", error);
    throw error;
  }
};